module.exports = __webpack_public_path__ + "static/media/tag.fb925ff1.svg";